import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { WebParameterContext, viewData } from '../../../model/common';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../bizlogic/servicesbll';
import { MessageclientService } from '../../../service/messageclient.service';
import { GridBaseCase } from '../grid/grid.base.case';
declare var app;

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent extends GridBaseCase {
  title: string;
  fieldList: any = [];
  orderList: Array<any> = [];
  isOrderdetail = false;//是否显示订单详情
  constructor(
    private router: ActivatedRoute,
    private http: HttpCustomerService,
    private com: CommonService,
    private msg: MessageclientService
  ) { super(); }

  ngOnInit() {
    this.LoadData();
  }

  LoadData() {
    const that = this;
    const pageName = this.router.snapshot.paramMap.get("ConfigName");
    const type = this.router.snapshot.paramMap.get("type");
    const id = this.router.snapshot.paramMap.get("id");
    const ConfigName = that.template.content.element[0].selectItemList.gridViewConfigName;
    // console.log(id);
    if (ConfigName && id) {
      let body = new WebParameterContext();
      body.ConfigName = ConfigName;
      body.OpType = "query";
      body.ConfigType = "view";
      body.Client.PageName = pageName;
      body.Client.Name = ConfigName;
      body.RequestBody = JSON.stringify({ 'a_ID': id });
      // console.log(body,'body');
      // body.RequestBody = JSON.stringify({ 'a_FK_OrderMaster_ID': id });
      body['isOrderdetail'] = that.isOrderdetail;
      body = HandleWebParameterContextBeforeDBRequest(body);
      that.isOrderdetail = body['isOrderdetail'];
      delete body['isOrderdetail'];
      if (!body.ResponseMessage.Success) {
        that.msg.Alert(body.ResponseMessage.ErrorMessage);
        return;
      }
      this.http.post(app.DEFAULTURL, body).then(data => {
        setTimeout(function () {
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }, 100);
        data = HandleServerContextAfterDBRequest(body, data);
        if (data.ResponseMessage.Success) {
          that.orderList = [];
          data.Status.Datas.forEach((data, index) => {
            let _object: any = {};
            if (that.template.content.element.length > 0) {
              that.template.content.element[0].selectItemList.selectItem.forEach((items, indexs) => {
                if (items.bindingField) {
                  _object[items.bindingField] = data[items.field];
                }
                if (items.bindingField == 'date' && data[items.field]) {
                  items[items.bindingField] = data[items.field].replace('00:00:00', '');
                }
              });
              that.orderList.push(_object);
            }
          });
          // console.log(that.orderList,'that.orderList');

          that.fieldList = [];
          // element.selectItemList.selectItem.forEach(item => {
          //   that.fieldList.push({ key: item.text, val: data.Status[item.field] });
          // });
          // that.data.head = data.Status.a_TitleMingChen;
          // that.data.title = data.Status.a_DingWeiKongJian;
          // that.data.date = data.Status.a_RiQiKongJian;
          // that.data.remark = decodeURI(data.Status.a_BeiZhuXinXi);
        } else {
          console.log(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
        that.loading = true;
      })
    }

  }

  /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event) {
    this.LoadData();
    event.target.complete();
  }

}
